// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chat feedback visual contract (docs/03 §"Chat feedback visual system"):
   one subtle grouped surface, hairline border, 12px radius, a small leading
   accent dot for identity (never a colored bar), and a white raised inner
   panel for dense content. */

.jtgPXeYF0984xdwDWvVk {
  background: var(--curio-surface-muted);
  border: 1px solid var(--curio-border);
  border-radius: 12px;
  padding: 12px 16px;
  margin-top: 8px;
  max-width: 100%;
}

.Sc12JWI90axa1E6gVTY6 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  font-weight: 600;
}
/* The default colour sits in :where() so it has no specificity: the chat panel's
   category tint class on the same element wins regardless of which stylesheet the
   bundler emits first (the dev/142 panel decomposition changed that order and the
   review/result cards lost their tint). */
:where(.Sc12JWI90axa1E6gVTY6) {
  color: var(--curio-text-primary);
}

.FOZE8gHQMFC3uyo1BLn2 {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
  flex: 0 0 auto;
}

.So_yc2XGoK_4FPyxxZON {
  font-weight: 400;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--curio-text-meta);
  flex: 0 0 auto;
  white-space: nowrap;
}

.qPxCRSuAW1XNFWdI08y2 {
  background: var(--curio-card-bg);
  border: 1px solid var(--curio-border);
  border-radius: 8px;
  padding: 8px 12px;
  margin-top: 8px;
}

.wkc4pGhVqccZXQy8hZ3o {
  font-size: 0.85rem;
  color: var(--curio-text-secondary);
  margin: 2px 0;
  white-space: pre-wrap;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/content/AgentChatCard.module.css"],"names":[],"mappings":"AAAA;;;6BAG6B;;AAE7B;EACE,sCAAsC;EACtC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;0CAG0C;AAC1C;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":["/* Chat feedback visual contract (docs/03 §\"Chat feedback visual system\"):\n   one subtle grouped surface, hairline border, 12px radius, a small leading\n   accent dot for identity (never a colored bar), and a white raised inner\n   panel for dense content. */\n\n.card {\n  background: var(--curio-surface-muted);\n  border: 1px solid var(--curio-border);\n  border-radius: 12px;\n  padding: 12px 16px;\n  margin-top: 8px;\n  max-width: 100%;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n/* The default colour sits in :where() so it has no specificity: the chat panel's\n   category tint class on the same element wins regardless of which stylesheet the\n   bundler emits first (the dev/142 panel decomposition changed that order and the\n   review/result cards lost their tint). */\n:where(.header) {\n  color: var(--curio-text-primary);\n}\n\n.accentDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: currentColor;\n  flex: 0 0 auto;\n}\n\n.kind {\n  font-weight: 400;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--curio-text-meta);\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n.inner {\n  background: var(--curio-card-bg);\n  border: 1px solid var(--curio-border);\n  border-radius: 8px;\n  padding: 8px 12px;\n  margin-top: 8px;\n}\n\n.line {\n  font-size: 0.85rem;\n  color: var(--curio-text-secondary);\n  margin: 2px 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `jtgPXeYF0984xdwDWvVk`,
	"header": `Sc12JWI90axa1E6gVTY6`,
	"accentDot": `FOZE8gHQMFC3uyo1BLn2`,
	"kind": `So_yc2XGoK_4FPyxxZON`,
	"inner": `qPxCRSuAW1XNFWdI08y2`,
	"line": `wkc4pGhVqccZXQy8hZ3o`
};
export default ___CSS_LOADER_EXPORT___;
